import { observer } from 'mobx-react';
import React from 'react';

import { NeighborButtons } from 'components/UI/NeighborButtons';
import store from 'stores/RootStore';

function NavigationMenu() {
  const adsManager = store.creative?.ads;
  const previousAd = adsManager?.previous;
  const nextAd = adsManager?.next;

  return (
    <NeighborButtons
      previous={{
        disabled: !previousAd,
        onClick: () => previousAd?.navigateTo(),
      }}
      next={{ disabled: !nextAd, onClick: () => nextAd?.navigateTo() }}
    />
  );
}

export default observer(NavigationMenu);
